import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../features/layout/lodaer";
import { ENV } from './env';
const uploadedDocs = [
  { label: "Risk Analyser", navigate: "/RiskAnalyser" },
  { label: "Sip Calculator", navigate: "/SipCalculator" },
  { label: "Lumpsum Calculator", navigate: "/LumpsumCalculator" },
  { label: "Glossary", navigate: "/Glossary" },
  { label: "Glossary Main Tech", navigate: "/GlossaryTech" },
  { label: "EbookMain", navigate: "/EbookMain" },
  { label: "Quiz", navigate: "/Quiz" },
  { label: "Regulatory Updates", navigate: "/RegulatoryUpdates" },
];
const Start = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  //
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const editnavigate = (x) => {
    setTimeout(() => {
      setLoading(false);
      navigate(x);
    }, 2000);
  };
  return (
    <>
      {!loading ? (
        <>
          {ENV.API_URL == "https://finwebdev.finlabsindia.org/" ? 
          <div className="other-quizes-section">
            <div className="other-quiz-list-container">
              <div className="row">
                {uploadedDocs.map((item, index) => {
                  return (
                    <>
                      <div className="col-2 border m-1 text-center">
                        <strong className="quiz-desc d-block">
                          {item.label}
                        </strong>
                        {/* <p className='quiz-desc'>Test your understanding of mutual fund fundamentals.</p> */}
                        <button
                          className="start-quiz"
                          onClick={() => editnavigate(item.navigate)}
                        >
                          {" "}
                          Launch {item.label}
                        </button>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>:  window.location.replace("https://finlabsindia.org")}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default Start;
